<template>
  <div class="main">
    <div class="container">
      <div class="select">
        <div class="demo-input-suffix">
          国家:
          <el-cascader
            v-model="value"
            :options="countryList"
            :props="{ value: 'id', label: 'name',multiple: true}"
            collapse-tags
            clearable
            size="mini"
          ></el-cascader>
        </div>
        <div class="demo-input-suffix">
          店铺名:
          <el-cascader
            v-model="value"
            :options="options"
            :props="{ value: 'id', label: 'name',multiple: true}"
            collapse-tags
            clearable
            size="mini"
          ></el-cascader>
        </div>
        <div class="demo-input-suffix">
          状态:
          <el-select
            class="searchInput searchInput2 searchInput3"
            size="mini"
            v-model="value"
            placeholder="请选择"
          >
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="demo-input-suffix trouInput">
          问题件:
          <el-cascader
            size="mini"
            v-model="value"
            :options="options"
            :props="{ value: 'id', label: 'name',multiple: true}"
            collapse-tags
            class="trousItem"
            clearable></el-cascader>
        </div>
      </div>
      <div class="search">
        <span>
          <el-button type="primary" size="mini">导出订单</el-button>
          <el-button
            class="searchBtn"
            size="mini"
            type="primary"
          >一键发货</el-button>
          <el-button
            class="searchBtn"
            size="mini"
            type="primary"
          >回传运单</el-button>
          <el-button class="searchBtn" size="mini" type="primary">批量操作问题件</el-button>
        </span>
        <div>
          <el-input
            class="searchInput searchInput2"
            size="mini"
            v-model="value"
            placeholder="请输入"
          ></el-input>
          <el-button size="mini" type="primary">查询</el-button>
        </div>
      </div>
      <el-alert type="info">
        <span style="margin-right:30px;">
          共计
          <span style="font-weight:600;color:red;font-size:16px;">{{orderResult.total}}</span>个订单
        </span>
        <span style="margin-right:30px;">
          店铺数量：
          <span
            style="font-weight:600;font-size:16px;"
          ></span>个
        </span>
        <span style="margin-right:30px;">
          待确认订单：
          <span style="font-weight:600;font-size:16px;">{{orderResult.waitnum}}</span>个
        </span>
        <span style="margin-right:30px;">
          已发货订单：
          <span style="font-weight:600;font-size:16px;">{{orderResult.finishnum}}</span>个
        </span>
        <span>
          未发货订单：
          <span style="font-weight:600;font-size:16px;">{{orderResult.noshipnum}}</span>个
        </span>
      </el-alert>
      <div class="BigContent" v-if="orderResult.page.length">
        <div class="itemNav">
          <span>
            <el-checkbox v-model="allChecked" @change="allChenkedChange"></el-checkbox>
          </span>
          <span>序号</span>
          <span>订单号</span>
          <span>自定义单号</span>
          <span>店铺</span>
          <span>订单金额</span>
          <span>运费</span>
          <span>付款</span>
          <span>状态</span>
          <span>运单号</span>
          <span>问题件</span>
          <span>创建时间</span>
        </div>
        <div
          class="item"
          v-for="(item,index) in orderResult.page"
          :key="item.id"
        >
          <span @click.stop>
            <el-checkbox v-model="item.isFlag" @change="(e)=>singleChecked(e,item.id)"></el-checkbox>
          </span>
          <span @click.stop>{{ index+1 }}</span>
          <span @click.stop>{{ item.id }}</span>
          <span @click.stop>{{ item.diyorderno}}</span>
          <span>{{ item.shopName }}</span>
          <span>{{ item.finalPrice }}</span>
          <span>{{ item.fare }}</span>
          <span>
            <is-flag :flag="item.isPay" :title="['已付款','未付款']"></is-flag>
          </span>
          <span class="flowContent">
            <el-button
              :class="['flow',item.flow==='未发货'?'noship':'',item.flow==='待确认'?'isConfirm':'']"
              size="mini"
              slot="reference"
            >{{ item.flow }}</el-button>
          </span>
          <span>{{ item.trackingno?item.trackingno:"-" }}</span>
          <span @click.stop="editTrou(item.id)">
            <span :class="['trouStatus',item.trouble!='正常'?'trouStatus2':'']"></span>
            {{ item.trouble }}
          </span>
          <span>{{ item.createTime }}</span>
        </div>
        <!-- 分页 -->
        <div class="pag">
          <span>
            共
            <span style="font-weight:600;color:red;font-size:16px;">{{ orderResult.total }}</span>条
          </span>
          <el-pagination
            background
            :page-count="orderResult.pnum"
            :page-sizes="[ 100, 300,500,1000]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="pageChange"
            @size-change="sizeChange"
          ></el-pagination>
        </div>
      </div>
      <div class="emptyData" v-else>暂无数据</div>
    </div>
    <!-- 修改问题件 -->
    <el-dialog title="修改问题件" :visible.sync="dialogFormVisible" width="500px">
      <div class="demo-input-suffix">
        问题件:
        <el-select
          class="searchInput searchInput2"
          size="mini"
          v-model="value"
          placeholder="请选择"
        >
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small">确 定</el-button>
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 一键发货选择发货物流 -->
    <el-dialog title="选择发货渠道" :visible.sync="dialogFormVisible2" width="500px">
      <div class="demo-input-suffix">
        发货渠道:
        <el-select
          class="searchInput searchInput2"
          size="mini"
          v-model="value"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small">确 定</el-button>
        <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import isFlag from "../../components/isFlag";
import {
  getOrder
} from "../../service";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      dialogFormVisible: false,
      dialogFormVisible2: false, //一键发货弹出层
      input: "",
      allChecked: false,
      options:[],
      size: 100, //每页显示条数，默认显示100条每页
      countrys:[],
      value: "",
      sids:[],
      countryList: [], //国家下拉列表数据
      orderResult: { page: [] }, //订单列表数据
      props: { multiple: true },
    };
  },
  created() {
    this.getOrderData();
  },
  methods: {
    ...mapMutations(["setOrderDetailParams"]),
    // 获取订单列表数据
    getOrderData(p = 1) {
      let params = {
        p,
        size: this.size
      };
      getOrder(params).then(res => {
        if (res.data.code === 0) {
          this.orderResult = res.data.result;
          this.orderResult.page.map((item, i) => {
            item.isFlag = false;
          });
          this.singleChangeAll();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开修改问题件
    editTrou(id) {
      this.dialogFormVisible = true;
      this.editTrouid = id;
      this.editisNormal = "";
    },
    // 分页
    pageChange(p) {
      this.allChecked = false;
      this.pageNum = p;
      this.getOrderData(p);
    },
    // 分页的每页条数发生改变
    sizeChange(val) {
      this.size = val;
      this.getOrderData();
    },
    // 点击改变单选
    singleChecked(e, id) {
      let arr = JSON.parse(JSON.stringify(this.orderResult.page));
      arr.map((item, i) => {
        if (item.id === id) {
          this.$set(item, "isFlag", e);
        }
      });
      this.orderResult.page = JSON.parse(JSON.stringify(arr));
      this.singleChangeAll(e);
    },
    // 点击全选改变单选
    allChenkedChange(e) {
      let arr = JSON.parse(JSON.stringify(this.orderResult.page));
      arr.map((item, i) => {
        arr[i].isFlag = e;
      });
      this.orderResult.page = JSON.parse(JSON.stringify(arr));
    },
    // 单选改变全选
    singleChangeAll() {
      let arr = JSON.parse(JSON.stringify(this.orderResult.page));
      let flag = false;
      arr.map((el, i) => {
        if (el.isFlag === false) {
          flag = true;
        }
      });
      if (flag === false) {
        this.allChecked = true;
      } else {
        this.allChecked = false;
      }
    },
  },
  mounted() {},
  components: {
    isFlag
  }
};
</script>

<style lang="less" scoped>
.main {
  background-color: #fff;
  border: 1px solid rgba(235, 237, 248, 1);
}
.container {
  width: 100%;
  padding: 0 20px;
  padding-top: 20px;
  border: none;
  box-sizing: border-box;
  .search {
    margin-left: auto;
    justify-content: space-between;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    > span {
      > span {
        color: #0077ff;
        display: inline-block;
        text-align: center;
        margin-right: 12px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    > div {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: row;
    }
    .searchInput {
      width: 180px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      border-radius: 0;
      margin-right: 6px;
    }
    .searchInput2 {
      // width: 120px;
    }

    .searchBtn2 {
      height: 28px;
      border-radius: 0;
    }
    .searchBtn {
      margin-left: 6px;
    }
    .searchContent {
      border: 1px solid rgba(221, 224, 227, 1);
      height: 26px;
      margin-right: 0px;
    }
  }
  .total {
    width: 121px;
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 12px;
    margin: 10px 0;
  }
  .itemNav,
  .item {
    padding-left: 18px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 20px;
      display: inline-block;
      margin-right: 0;
      height: 48px;
      line-height: 48px;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 4%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 7%;
    }
    span:nth-child(7) {
      display: inline-block;
      text-align: center;
      width: 7%;
    }
    span:nth-child(8) {
      display: inline-block;
      text-align: center;
      width: 8%;
    }
    span:nth-child(9) {
      display: inline-block;
      text-align: center;
      width: 100px;
    }
    span:nth-child(10) {
      display: inline-block;
      text-align: center;
      width: 12%;
    }

    span:nth-child(11) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(12) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
  }
  .itemNav {
    margin-bottom: 10px;
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 48px;
    &:hover {
      cursor: pointer;
      background-color: #eee;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(6) {
      color: #ffa000;
    }
    span:nth-child(8) {
      color: #333333;
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
.isFlag {
  width: 59px;
  height: 24px;
  background: rgba(223, 227, 232, 1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 0 13px;
  font-size: 12px;
  > span:first-child {
    width: 0 !important;
    box-sizing: border-box;
    border: 6px solid #999;
    display: inline-block;
    border-radius: 50%;
  }
  > p {
    display: inline-block;
    height: 14px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    margin-left: 10px;
  }
}
.dialog-footer {
  text-align: center;
}
.demo-input-suffix {
  margin-right: 4px;
}
.emptyData {
  text-align: center;
  width: 100%;
  line-height: 200px;
  font-size: 20px;
  color: #e6e6e6;
}
.trouStatus {
  display: inline-block;
  width: 0px !important;
  height: 0px !important;
  border: 2.5px solid green;
  border-radius: 50%;
  margin: 0 4px;
  margin-right: 4px !important;
  margin-bottom: 2px;
}
.trouStatus2 {
  border: 2.5px solid red;
  margin-bottom: 2px;
}
.flowContent {
  display: flex !important;
  position: relative;
}
.flow {
  border: none;
  border-radius: 13px;
  background-color: #dfe3e8;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.noship {
  background-color: #ffe990;
}
.isConfirm {
  background-color: #fec48d;
}
.finishOk {
  color: #67c23a;
}
.finishNo {
  color: #909399;
}
.selectCheck {
  width: 10px;
  height: 10px;
  border: 1px solid #dcdfe6;
  transform: translate(0%, 90%);
}
.select {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
}
.trouInput {
  margin-right: 0px !important;
}
.searchInput3 {
  width: 90px;
}
/deep/ .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 280px;
}
.trousItem{
  /deep/ input{
    width: 220px;
  }
}
</style>